module.exports = __webpack_public_path__ + "img/03mazda-miata-rf-angle.34121db4.png";